const fullValidation = (intl) => ({
  name_translations,
}) => {
  let errors = {};

  if(!name_translations || name_translations.length === 0) {
    errors.name_translations = intl.formatMessage({ id: "form_error_required"});
  }

  return errors;
};

export default fullValidation;
